import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import humanTime from 'flarum/common/helpers/humanTime';

/**
 * Discovery results under Messages search (conversations + people).
 * Never renders message bodies/previews.
 */
export default class MessagesDiscoveryResults extends Component {
  view() {
    const {
      conversations = [],
      people = [],
      peopleHeading = 'People',
      conversationsHeading = 'Conversations',
      emptyLabel = 'No conversations or people found',
      loadingPeople = false,
      activeIndex = -1,
      onActivateConversation = null,
      onActivatePerson = null,
      showEmpty = false
    } = this.attrs;
    const items = [];
    let index = 0;
    if (conversations.length > 0) {
      items.push(m("div", {
        className: "MessagesDiscovery-section",
        key: "conversations-heading"
      }, m("h2", {
        className: "MessagesDiscovery-heading",
        id: "messages-discovery-conversations"
      }, conversationsHeading), m("ul", {
        className: "MessagesDiscovery-list",
        role: "listbox",
        "aria-labelledby": "messages-discovery-conversations"
      }, conversations.map(conversation => {
        const optionIndex = index++;
        const active = optionIndex === activeIndex;
        const live = conversation.kind === 'live';
        const count = Number(conversation.liveUserCount);
        const hasLiveCount = live && conversation.liveUserCount != null && Number.isFinite(count) && count > 0;
        const liveText = hasLiveCount ? `LIVE ${Math.floor(count)}` : 'LIVE';
        const activity = conversation.activityAt ? humanTime(new Date(conversation.activityAt)) : null;
        return m("li", {
          key: conversation.id,
          className: 'MessagesDiscovery-option' + (active ? ' is-active' : ''),
          role: "option",
          "aria-selected": active ? 'true' : 'false',
          id: `messages-discovery-option-${optionIndex}`,
          "data-discovery-index": optionIndex
        }, m("button", {
          type: "button",
          className: "MessagesDiscovery-optionButton",
          onmousedown: e => e.preventDefault(),
          onclick: () => {
            if (typeof onActivateConversation === 'function') {
              onActivateConversation(conversation);
            }
          }
        }, m("span", {
          className: "MessagesDiscovery-optionAvatar",
          "aria-hidden": "true"
        }, conversation.avatarUrl ? m("img", {
          className: "Avatar",
          src: conversation.avatarUrl,
          alt: ""
        }) : m("span", {
          className: "ConversationRow-icon",
          "aria-hidden": "true"
        }, m("i", {
          className: live ? 'fas fa-comments' : 'fas fa-user'
        }))), m("span", {
          className: "MessagesDiscovery-optionText"
        }, m("span", {
          className: "MessagesDiscovery-optionTitle"
        }, conversation.title), m("span", {
          className: "MessagesDiscovery-optionMeta"
        }, live ? m("span", {
          style: {
            color: 'var(--messages-live-accent)'
          }
        }, "PUBLIC \xB7 ", m("i", {
          className: "fas fa-globe",
          "aria-hidden": "true"
        }), " ", liveText) : m("span", null, "PRIVATE \xB7 ", m("i", {
          className: "fas fa-lock",
          "aria-hidden": "true"
        }), activity ? ` ${activity}` : ''))), conversation.unreadCount > 0 ? m("span", {
          className: "MessagesDiscovery-unread"
        }, conversation.unreadCount) : null));
      }))));
    }
    if (people.length > 0 || loadingPeople) {
      items.push(m("div", {
        className: "MessagesDiscovery-section",
        key: "people-heading"
      }, m("h2", {
        className: "MessagesDiscovery-heading",
        id: "messages-discovery-people"
      }, peopleHeading), loadingPeople ? m("div", {
        className: "MessagesDiscovery-status",
        "aria-live": "polite"
      }, "Loading people\u2026") : m("ul", {
        className: "MessagesDiscovery-people",
        role: "listbox",
        "aria-labelledby": "messages-discovery-people"
      }, people.map(person => {
        const optionIndex = index++;
        const active = optionIndex === activeIndex;
        return m("li", {
          key: person.id,
          className: 'MessagesDiscovery-person' + (active ? ' is-active' : ''),
          role: "option",
          "aria-selected": active ? 'true' : 'false',
          id: `messages-discovery-option-${optionIndex}`,
          "data-discovery-index": optionIndex
        }, m("button", {
          type: "button",
          className: "MessagesDiscovery-optionButton",
          onmousedown: e => e.preventDefault(),
          onclick: () => {
            if (typeof onActivatePerson === 'function') {
              onActivatePerson(person);
            }
          }
        }, m("span", {
          className: "MessagesDiscovery-personAvatar",
          "aria-hidden": "true"
        }, person.user ? m(Avatar, {
          user: person.user,
          alt: ""
        }) : m("span", {
          className: "Avatar"
        }, "?")), m("span", {
          className: "MessagesDiscovery-personText"
        }, m("span", {
          className: "MessagesDiscovery-personName"
        }, person.displayName), person.hint ? m("span", {
          className: "MessagesDiscovery-personHint"
        }, person.hint) : null)));
      }))));
    }
    if (showEmpty && conversations.length === 0 && people.length === 0 && !loadingPeople) {
      items.push(m("div", {
        className: "MessagesDiscovery-empty",
        key: "empty",
        role: "status"
      }, emptyLabel));
    }
    return m("div", {
      className: "MessagesDiscovery"
    }, items);
  }
}
flarum.reg.add('flatrate-messaging-ui', 'forum/components/MessagesDiscoveryResults', MessagesDiscoveryResults);